import { useLanguage } from '../LanguageContext';
import CalendarIcon from '../icons/CalendarIcon';
import PhotoIcon from '../icons/PhotoIcon';

export default function StoryNavBar({ pages, currentPageIndex, onSelectPage }) {
  const { t } = useLanguage();

  const homeIndex = pages.findIndex((p) => p.key === 'home');
  const photoboardIndex = pages.findIndex((p) => p.key === 'photoboard');
  const scheduleIndex = pages.findIndex((p) => p.key === 'schedule');

  return (
    <nav
      className="absolute bottom-0 left-0 right-0 z-50"
      style={{ height: '104px', pointerEvents: 'none' }}
    >
      {/* Bar background — lower 72px */}
      <div
        className="absolute bottom-0 left-0 right-0 h-[72px] nav-topbar border-t"
        style={{ borderTopColor: '#dcc7cb', pointerEvents: 'auto' }}
      />

      {/* Nav items — within the 72px bar */}
      <div
        className="absolute bottom-0 left-0 right-0 flex"
        style={{ height: '72px', pointerEvents: 'auto' }}
      >
        {/* LEFT — Photo Board */}
        <button
          onClick={() => photoboardIndex >= 0 && onSelectPage(photoboardIndex)}
          className="flex flex-col items-center justify-center flex-1 h-full gap-1 transition-colors duration-200"
          style={{
            color: currentPageIndex === photoboardIndex ? '#c87d87' : '#dcc7cb',
          }}
        >
          <PhotoIcon className="w-6 h-6" />
          <span className="text-xs text-nav-text tracking-wider uppercase">
            {t('nav.photoboard')}
          </span>
        </button>

        {/* CENTER — Home floating circular button */}
        <div className="relative flex flex-col items-center justify-end flex-1 h-full pb-2">
          <button
            onClick={() => homeIndex >= 0 && onSelectPage(homeIndex)}
            className="absolute"
            style={{ bottom: '36px' }}
          >
            <div
              className={`w-16 h-16 rounded-full shadow-lg border-4 overflow-hidden transition-all duration-200 ${
                currentPageIndex === homeIndex ? 'scale-110' : 'scale-100'
              }`}
              style={{
                borderColor:
                  currentPageIndex === homeIndex ? '#c87d87' : '#dcc7cb',
              }}
            >
              <img
                src="/logo_main.webp"
                alt="Home"
                className="w-full h-full object-cover"
              />
            </div>
          </button>
          <span
            className="text-xs text-nav-text tracking-wider uppercase transition-colors duration-200"
            style={{
              color: currentPageIndex === homeIndex ? '#c87d87' : '#b0a0a2',
            }}
          >
            {t('nav.home')}
          </span>
        </div>

        {/* RIGHT — Schedule */}
        <button
          onClick={() => scheduleIndex >= 0 && onSelectPage(scheduleIndex)}
          className="flex flex-col items-center justify-center flex-1 h-full gap-1 transition-colors duration-200"
          style={{
            color: currentPageIndex === scheduleIndex ? '#c87d87' : '#dcc7cb',
          }}
        >
          <CalendarIcon className="w-6 h-6" />
          <span className="text-xs text-nav-text tracking-wider uppercase">
            {t('nav.schedule')}
          </span>
        </button>
      </div>
    </nav>
  );
}
